import { API_URL } from "@/config";
import axios, { AxiosError } from "axios";

export const privateApi = axios.create({
    baseURL: API_URL,
});

privateApi.interceptors.request.use((config) => {
    try {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
    } catch (error) {
        console.error("Erreur lors de la récupération du token", error);
    }
    return config;
});

privateApi.interceptors.response.use(
    (response) => response, 
    (error) => {
        if (error.response?.status === 401) {
            localStorage.removeItem('token');
            if (
                typeof window !== "undefined" &&
                !window.location.hash.startsWith('#/login')
            ) {
                window.location.href = "/#/login";
            }
        }
        const axiosError = error as AxiosError;
        if (axiosError.response?.data && typeof axiosError.response.data === 'object') {
            const errorData = axiosError.response.data;
            return Promise.reject(errorData);
        }
        return Promise.reject(error);
    }
);
